/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const save_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m9 7.5 3 3m0 0 3-3m-3 3V.75m7.5 19.5h-15m14-3h-1m-15.25 6h19.5a1.5 1.5 0 0 0 1.5-1.5v-6a1.5 1.5 0 0 0-1.5-1.5H2.25a1.5 1.5 0 0 0-1.5 1.5v6a1.5 1.5 0 0 0 1.5 1.5Z"
    />
  </svg>
)
export default save_medium
